module.exports = __webpack_public_path__ + "static/img/empty.089007e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty.gif
// module id = 9LbY
// module chunks = 1